import BlockRange from '@intercom/embercom-composer/blocks/block-range';
import BlockSelection from '@intercom/embercom-composer/blocks/block-selection';
import CommandResult from './command-result';
import Em from 'ember';
export default Em.Object.extend({
  blockList: null,
  selection: null,
  snapshotState: Em.on('init', function () {
    this.set('firstSelectedBlock', this.get('selection.firstSelectedBlock'));
    this.set('lastSelectedBlock', this.get('selection.lastSelectedBlock'));
    this.set('coveredBlocks', this.get('selection.coveredBlocks'));
    this.set('isFirstSelectedBlockCovered', this.get('coveredBlocks').includes(this.get('firstSelectedBlock')));
    this.set('isFirstSelectedBlockNotCovered', !this.get('isFirstSelectedBlockCovered'));
    this.set('isLastSelectedBlockCovered', this.get('coveredBlocks').includes(this.get('lastSelectedBlock')));
    this.set('isLastSelectedBlockNotCovered', !this.get('isLastSelectedBlockCovered'));
    this.set('previousBlock', this._getPreviousBlock());
    this.set('hasNoPreviousBlock', !this.get('previousBlock'));
    this.set('nextBlock', this._getNextBlock());
    this.set('previousItem', this._getPreviousItem());
    this.set('firstSelectedBlockNotCoveredAndNotList', this.get('isFirstSelectedBlockNotCovered') && !this.get('firstSelectedBlock.isListType'));
    this.set('lastSelectedBlockNotCoveredAndNotList', this.get('isLastSelectedBlockNotCovered') && !this.get('lastSelectedBlock.isListType'));
    this.set('allBlocksCovered', this.get('isFirstSelectedBlockCovered') && this.get('isLastSelectedBlockCovered'));
    this.set('firstAndLastAreLists', this.get('firstSelectedBlock.isListType') && this.get('lastSelectedBlock.isListType'));
    this.set('firstSelectBlockNotCoveredAndIsList', this.get('firstSelectedBlock.isListType') && this.get('isFirstSelectedBlockNotCovered'));
    this.set('lastSelectBlockNotCoveredAndIsList', this.get('lastSelectedBlock.isListType') && this.get('isLastSelectedBlockNotCovered'));
    this.set('firstSelectedBlockAndPreviousAreLists', this.get('previousBlock') && this.get('previousBlock.isListType') && this.get('firstSelectedBlock.isListType'));
    if (!this.get('skipItemSelections')) {
      this._setItemSelections();
    }
  }),
  run() {
    if (this.get('selection.isZeroWidth')) {
      return this.processZeroWidth();
    }
    if (this.get('selection.isSingleBlock')) {
      return this.processSingleBlock();
    }
    if (this.get('selection.isMultiBlock')) {
      return this.processMultiBlock();
    }
  },
  setSelectionToStartOf(block) {
    let newSelection = BlockSelection.create();
    let blockIndex = this._blockIndex(block);
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: 0,
      startPositionIndex: 0,
      endBlockIndex: blockIndex,
      endItemIndex: 0,
      endPositionIndex: 0
    });
    this.get('selection').setSelection(newSelection);
  },
  setSelectionToBlockAfter(block) {
    let newSelection = BlockSelection.create();
    let blockIndex = this._blockIndex(block) + 1;
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: 0,
      startPositionIndex: 0,
      endBlockIndex: blockIndex,
      endItemIndex: 0,
      endPositionIndex: 0
    });
    this.get('selection').setSelection(newSelection);
  },
  setSelectionToStartOfItem(block, item) {
    let newSelection = BlockSelection.create();
    let blockIndex = this._blockIndex(block);
    let itemIndex = block.get('blockList').indexOf(item);
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: itemIndex,
      startPositionIndex: 0,
      endBlockIndex: blockIndex,
      endItemIndex: itemIndex,
      endPositionIndex: 0
    });
    this.get('selection').setSelection(newSelection);
  },
  setSelectionToEndOfItem(block, item) {
    let newSelection = BlockSelection.create();
    let blockIndex = this._blockIndex(block);
    let itemIndex = block.get('blockList').indexOf(item);
    let positionIndex = item.get('text.length');
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: itemIndex,
      startPositionIndex: positionIndex,
      endBlockIndex: blockIndex,
      endItemIndex: itemIndex,
      endPositionIndex: positionIndex
    });
    this.get('selection').setSelection(newSelection);
  },
  setSelectionToEndOf(block) {
    if (block.get('isListType')) {
      this._setSelectionToEndOfList(block);
    } else {
      this._setSelectionToEndOf(block);
    }
  },
  _setSelectionToEndOf(block) {
    let newSelection = BlockSelection.create();
    let blockIndex = this._blockIndex(block);
    let positionIndex = 0;
    if (!block.get('isMedia')) {
      positionIndex = block.get('text.length');
    }
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: 0,
      startPositionIndex: positionIndex,
      endBlockIndex: blockIndex,
      endItemIndex: 0,
      endPositionIndex: positionIndex
    });
    this.get('selection').setSelection(newSelection);
  },
  _setSelectionToEndOfList(listBlock) {
    let newSelection = BlockSelection.create();
    let blockIndex = this._blockIndex(listBlock);
    let itemIndex = listBlock.get('blockList.length') - 1;
    let endPositionIndex = listBlock.get('blockList.lastObject.text.length');
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: itemIndex,
      startPositionIndex: endPositionIndex,
      endBlockIndex: blockIndex,
      endItemIndex: itemIndex,
      endPositionIndex
    });
    this.get('selection').setSelection(newSelection);
  },
  moveSelectionRightBy(offset) {
    let newSelection = BlockSelection.create();
    let blockIndex = this.get('selection.startBlockIndex');
    let itemIndex = this.get('selection.startItemIndex');
    let positionIndex = this.get('selection.startPositionIndex') + offset;
    if (positionIndex < 0) {
      positionIndex = 0;
    }
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: itemIndex,
      startPositionIndex: positionIndex,
      endBlockIndex: blockIndex,
      endItemIndex: itemIndex,
      endPositionIndex: positionIndex
    });
    this.get('selection').setSelection(newSelection);
  },
  setSelectionToPositionIndex(startIndex, endIndex) {
    endIndex = endIndex || startIndex;
    let newSelection = BlockSelection.create();
    let blockIndex = this.get('selection.startBlockIndex');
    let itemIndex = this.get('selection.startItemIndex');
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: itemIndex,
      startPositionIndex: startIndex,
      endBlockIndex: blockIndex,
      endItemIndex: itemIndex,
      endPositionIndex: endIndex
    });
    this.get('selection').setSelection(newSelection);
  },
  setSelectionToItemAndPositionIndex(itemIndex, positionIndex) {
    let newSelection = BlockSelection.create();
    let blockIndex = this.get('selection.startBlockIndex');
    newSelection.setProperties({
      startBlockIndex: blockIndex,
      startItemIndex: itemIndex,
      startPositionIndex: positionIndex,
      endBlockIndex: blockIndex,
      endItemIndex: itemIndex,
      endPositionIndex: positionIndex
    });
    this.get('selection').setSelection(newSelection);
  },
  setSelectionToCoverBlock(block) {
    this.setSelectionToCoverBlocks(block, block);
  },
  setSelectionToCoverBlocks(startBlock, endBlock) {
    let newSelection = BlockSelection.create();
    newSelection.setProperties({
      startBlockIndex: this._blockIndex(startBlock),
      startItemIndex: 0,
      startPositionIndex: 0,
      endBlockIndex: this._blockIndex(endBlock),
      endItemIndex: endBlock.get('blockList.length') || 0,
      endPositionIndex: endBlock.get('blockList.lastObject.text.length') || endBlock.get('text.length')
    });
    this.get('selection').setSelection(newSelection);
  },
  applyActionToFirstSelectedBlock(action) {
    return this._applyActionToBlock(action, this.get('firstSelectedBlock'), this.get('selection'));
  },
  applyActionToLastSelectedBlock(action) {
    return this._applyActionToBlock(action, this.get('lastSelectedBlock'), this.get('selection'));
  },
  insertBlock(block, idx) {
    if (idx !== 0) {
      idx = idx || this.get('blockIndexAfterSelectionStart');
    }
    let blockListLength = this.get('blockList.length');
    if (idx < 0 || idx > blockListLength) {
      throw new Error(`Cannot insert block at index [${idx}]. The allowed insertion range is 0 to ${blockListLength}.`);
    } else {
      this.get('blockList').insertAt(idx, block);
    }
  },
  insertBlocks(blocks, index) {
    blocks.forEach(function (block) {
      this.insertBlock(block, index);
      index++;
    }, this);
  },
  insertDefaultBlock(idx) {
    if (idx !== 0) {
      idx = idx || this.get('blockIndexAfterSelectionStart');
    }
    return this.get('blockList').insertDefaultBlockAt(idx);
  },
  removeBlock(block) {
    this.get('blockList').removeObject(block);
  },
  removeFirstSelectedBlock() {
    this.removeBlock(this.get('firstSelectedBlock'));
  },
  removeBlocks(blocks) {
    if (blocks) {
      this.get('blockList').removeObjects(blocks);
    }
  },
  collapseSelection() {
    let newSelection = BlockSelection.create();
    newSelection.setProperties({
      startBlockIndex: this.get('selection.startBlockIndex'),
      startItemIndex: this.get('selection.startItemIndex'),
      startPositionIndex: this.get('selection.startPositionIndex'),
      endBlockIndex: this.get('selection.startBlockIndex'),
      endItemIndex: this.get('selection.startItemIndex'),
      endPositionIndex: this.get('selection.startPositionIndex')
    });
    this.get('selection').setSelection(newSelection);
  },
  collapseSelectionToRight() {
    let newSelection = BlockSelection.create();
    newSelection.setProperties({
      startBlockIndex: this.get('selection.endBlockIndex'),
      startItemIndex: this.get('selection.endItemIndex'),
      startPositionIndex: this.get('selection.endPositionIndex'),
      endBlockIndex: this.get('selection.endBlockIndex'),
      endItemIndex: this.get('selection.endItemIndex'),
      endPositionIndex: this.get('selection.endPositionIndex')
    });
    this.get('selection').setSelection(newSelection);
  },
  expandSelectionLeftBy(offset) {
    this.decrementProperty('selection.startPositionIndex', offset);
  },
  expandSelectionRightBy(offset) {
    this.incrementProperty('selection.endPositionIndex', offset);
  },
  blockIndexAfterSelectionStart: Em.computed('selection.startBlockIndex', function () {
    return this.get('selection.startBlockIndex') + 1;
  }),
  processBlockMutationResult(result, forceRerender) {
    let shouldRerender = forceRerender || result.get('shouldRerender');
    let positionDiff = result.get('blockRange.startPoint.positionIndex') - this.get('selection.startPositionIndex');
    if (result.get('hasBlocksToAdd')) {
      this.insertBlocks(result.get('blocksToAdd'), this.get('selection.startBlockIndex') + 1);
      this.removeBlocks(result.get('blocksToRemove'));
      if (result.get('blocksToAdd.lastObject.isMedia')) {
        this.setSelectionToStartOf(this.insertDefaultBlock());
      } else {
        this.setSelectionToStartOf(result.get('blocksToAdd.firstObject'));
      }
      return CommandResult.create({
        shouldRerender: true
      });
    } else if (result.blockRange && positionDiff !== 1) {
      this.setSelectionToPositionIndex(result.get('blockRange.startPoint.positionIndex'));
      return CommandResult.create({
        shouldRerender: true
      });
    } else if (result.blockRange) {
      this.setSelectionToPositionIndex(result.get('blockRange.startPoint.positionIndex'));
    }
    return CommandResult.create({
      shouldRerender
    });
  },
  _setItemSelections() {
    this.set('firstSelectedBlockItemSelection', this._getFirstSelectedBlockItemSelection());
    this.set('lastSelectedBlockItemSelection', this._getLastSelectedBlockItemSelection());
  },
  _getFirstSelectedBlockItemSelection() {
    let firstSelectedBlock = this.get('firstSelectedBlock');
    let newSelection = BlockSelection.create();
    if (this.get('selection.isSingleBlock')) {
      newSelection.setProperties({
        startBlockIndex: this.get('selection.startItemIndex'),
        startItemIndex: 0,
        startPositionIndex: this.get('selection.startPositionIndex'),
        endBlockIndex: this.get('selection.endItemIndex'),
        endItemIndex: 0,
        endPositionIndex: this.get('selection.endPositionIndex')
      });
    } else {
      newSelection.setProperties({
        startBlockIndex: this.get('selection.startItemIndex'),
        startItemIndex: 0,
        startPositionIndex: this.get('selection.startPositionIndex'),
        endBlockIndex: firstSelectedBlock.get('blockList.length') - 1,
        endItemIndex: 0,
        endPositionIndex: firstSelectedBlock.get('blockList.lastObject.text.length')
      });
    }
    return newSelection;
  },
  _getLastSelectedBlockItemSelection() {
    let newSelection = BlockSelection.create();
    if (this.get('selection.isSingleBlock')) {
      newSelection.setProperties({
        startBlockIndex: this.get('selection.startItemIndex'),
        startItemIndex: 0,
        startPositionIndex: this.get('selection.startPositionIndex'),
        endBlockIndex: this.get('selection.endItemIndex'),
        endItemIndex: 0,
        endPositionIndex: this.get('selection.endPositionIndex')
      });
    } else {
      newSelection.setProperties({
        startBlockIndex: 0,
        startItemIndex: 0,
        startPositionIndex: 0,
        endBlockIndex: this.get('selection.endItemIndex'),
        endItemIndex: 0,
        endPositionIndex: this.get('selection.endPositionIndex')
      });
    }
    return newSelection;
  },
  _getPreviousBlock() {
    return this.get('blockList').objectAt(this.get('selection.startBlockIndex') - 1);
  },
  _getNextBlock() {
    return this.get('blockList').objectAt(this.get('selection.startBlockIndex') + 1);
  },
  _getPreviousItem() {
    let block = this.get('blockList').objectAt(this.get('selection.startBlockIndex'));
    if (block && block.get('blockList')) {
      return block.get('blockList').objectAt(this.get('selection.startItemIndex') - 1);
    }
  },
  _blockIndex(block) {
    return this.get('blockList').indexOf(block);
  },
  _applyActionToBlock(action, block, selection) {
    let blockRange = this._blockRangeForSelection(block, selection);
    return block.applyAction(action, blockRange, this.get('options'));
  },
  _blockRangeForSelection(block, selection) {
    let startItemIndex, startPositionIndex, endItemIndex, endPositionIndex;
    startItemIndex = 0;
    startPositionIndex = 0;
    endPositionIndex = block.get('text.length') || block.get('blockList.lastObject.text.length') || 0;
    endItemIndex = block.get('blockList.length') || 0;
    if (block === this.get('firstSelectedBlock')) {
      startItemIndex = selection.get('startItemIndex');
      startPositionIndex = selection.get('startPositionIndex');
    }
    if (block === this.get('lastSelectedBlock')) {
      endItemIndex = selection.get('endItemIndex');
      endPositionIndex = selection.get('endPositionIndex');
    }
    return BlockRange.atItemAndPositionIndex(startItemIndex, startPositionIndex, endItemIndex, endPositionIndex);
  }
});